import * as Api from '@ViewModels';
import { TemplateType } from '@ViewModels';
import * as React from 'react';
import { ICreateCampaignRequest, ILocationState, TemplateOrTemplateFilter } from '../../../../../models';
import { BlogPostRequest } from '../../../../../models/Blogs';
import { useFullscreenModal } from '../../../../../models/hooks/appStateHooks';
import { useEventLogging } from '../../../../../models/Logging';

export function useLaunchCampaignFromTemplate({
	queryCommand: templateCommand,
	eventLoggingCategory,
}: {
	queryCommand: Api.ITemplateCommand;
	eventLoggingCategory: string;
}) {
	const fullscreenModal = useFullscreenModal();
	const { logEvent } = useEventLogging(eventLoggingCategory);
	React.useEffect(() => {
		if (templateCommand?.command === 'templates') {
			const isSocial = templateCommand.template.templateType === TemplateType.SocialMediaPost;
			const isBlog = templateCommand.template.templateType === TemplateType.Blog;

			if (templateCommand) {
				const locationState: ILocationState<any, ICreateCampaignRequest<TemplateOrTemplateFilter> | BlogPostRequest> = {
					model: {
						schedule: {
							criteria:
								templateCommand.sendOption === 'now'
									? Api.ScheduleCriteria.Immediately
									: Api.ScheduleCriteria.StartAfter,
							startDate: templateCommand.date,
						},
						tags: templateCommand.tags,
						type: 'Template',
					},
				};
				if (isSocial) {
					(locationState.model as any).context = templateCommand.template;
				} else if (isBlog) {
					Object.assign(locationState.model, {
						template: templateCommand.template,
					});
				}
				fullscreenModal?.history.push({
					pathname: isSocial
						? `/social-media/post/create/from-template`
						: isBlog
							? `/blog/post/create-from-template/${templateCommand.id}`
							: `/email/campaigns/create/from-template/${templateCommand.id}`,
					state: locationState,
				});
				logEvent('AppLink-Template', {
					id: templateCommand.id,
					op: templateCommand.op,
				});
			}
		}
	}, [templateCommand, logEvent, fullscreenModal]);
}
